/* This component DELETES one entry from the historys collection in MongoDB. */

import React, { useState }                      from 'react'
import ActionWarning                            from '../Components/ActionWarning.js'
import axios                                    from 'axios'
import {
   Box,
   Dialog,
   DialogContent,
   Grid
}                                               from'@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import GuestBioTitleReadComponent               from './GuestBioTitleReadComponent'
import { node_server }                          from '../Helpers'

const GuestBioDeleteComponent = () => {

   /* This causes the GuestBioTitleReadComponent to re-render on the deletioon and show the
      new list of titles with the deleted one having been removed. */
   const [ data,                                setData              ]  =  useState([])
   const [ selectedUserId,                      setSelectedUserId    ]  =  useState('')
   const [ showActionWarning,                   setShowActionWarning ]  =  useState(false)

   const actionText = 'This action will delete a Guest Bio from the database. This action is irreversible.'
   
   const handleClick = (id) => {
      setSelectedUserId(id)
      setShowActionWarning(true)
   }

   /* This executes the selected action after the SuperUser has clicked on an action and then
      selected execute in ActionWarning. */
   const continueAction = async () => {
      setShowActionWarning(false)
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.delete(node_server + `guestBio/${selectedUserId}`)
         .then( res => res.data )
         .then( data => {
            setData(data.allGuestBioTitles)
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
   }

   /* This is called by the cancel button in the ActionWarnkng component. This caused the selected
      action to not be executed. */
   const cancelAction = () => {
      setShowActionWarning(false)
   }

   return (
      <Box style={{ marginTop: '6rem', marginBottom: '1rem' }} >
         <Grid>
            <GuestBioTitleReadComponent data={data} handleClick={handleClick} />
         </Grid>
         <Grid container item xs={12} sm={6} justifyContent='flex-start' style={{marginTop: '15rem'}} >
            { showActionWarning
               ?
                  <Dialog
                     open={true}
                  >
                     <DialogContent>
                        <ActionWarning actionText={actionText} cancelAction={cancelAction} continueAction={continueAction} height={150} width={350} />
                     </DialogContent>
                  </Dialog>
               :
                  null
            }
         </Grid>
      </Box>
   )
}

export default GuestBioDeleteComponent

